import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from 'src/Services/report.service';
import { CheckAuth } from 'src/Services/utility.service';
import * as Chart from 'chart.js';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-briefings-stats-report',
  templateUrl: './briefings-stats-report.component.html',
  styleUrls: ['./briefings-stats-report.component.css']
})
export class BriefingsStatsReportComponent {
  loginuserID: any;
  isloading = false;
  SelectedTool = '';
  tokenKey: string = '';

  isShowprogressSpinner: boolean = false;
  blockedDocument: boolean = false;

  monthYearData: any[] = [];
  displayedColumns: string[] = [];

  dropdownListYear = [];
  selectedItemsYear = [];
  dropdownSettingsYear = {};
  listOfYearIds = [];
  selectedFromYear: number = 0;

  dropdownListToYear = [];
  selectedItemsToYear = [];
  dropdownSettingsToYear = {};
  selectedToYear: number = 0;

  public barChartLabels: string[] = [];
  yearColors = {};
  monthYearDataForChart: any[] = [];

  constructor(private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly reportService: ReportService,
    private readonly toastrService: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.loginuserID = this.sessionStorageService.getAdminUserId();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('Briefings Stats Report');
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();

    this.dropdownSettingsYear = {
      singleSelection: true,
      text: "Select From Year",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No Year available',
      showCheckbox: false,
      enableFilterSelectAll: false
    };

    this.dropdownSettingsToYear = {
      singleSelection: true,
      text: "Select To Year",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No Year available',
      showCheckbox: false,
      enableFilterSelectAll: false
    };

    this.GetYearFromBriefingMaster();
  }

  GetYearFromBriefingMaster() {
    this.isloading = true;
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
    this.reportService.GetYearFromBriefingMaster(this.tokenKey).subscribe(data => {
      this.isloading = false;
      this.isShowprogressSpinner = false;
      this.blockedDocument = false;
      if (data) {
        if (data.status == "Success") {
          for (const itemyear of data["yearList"]) {
            this.dropdownListYear.push({ "id": itemyear.year, "itemName": itemyear.year });
            this.dropdownListToYear.push({ "id": itemyear.year, "itemName": itemyear.year });
          }
        }
      }
    })
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastrService.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastrService.error(msg, msgTitle));
    }
  }

  private myChart: Chart | null = null;

  GetBriefingStatesReport() {
    if (!this.validateYears()) return;

    this.isloading = true;
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
    this.monthYearData = [];
    this.monthYearDataForChart = [];

    this.reportService.GetBriefingStats(this.tokenKey, this.selectedFromYear, this.selectedToYear).subscribe(data => {
      this.isloading = false;
      this.isShowprogressSpinner = false;
      this.blockedDocument = false;

      if (data.status == "Success") {
        this.monthYearData = data["yearList"];
        this.monthYearDataForChart = data["yearList"];

        if (this.monthYearData.length > 0) {
          this.setDisplayedColumns();
          this.initializeChart();
        }
      }
    });
  }

  validateYears() {
    if (this.selectedFromYear === 0) {
      this.showMessage("Please select From Year", 'Error', 'error');
      return false;
    }
    if (this.selectedToYear === 0) {
      this.showMessage("Please select To Year", 'Error', 'error');
      return false;
    }
    if (this.selectedFromYear > this.selectedToYear) {
      this.showMessage("Please select To Year greater than From Year", 'Error', 'error');
      return false;
    }
    return true;
  }

  setDisplayedColumns() {
    this.displayedColumns = Object.keys(this.monthYearData[0]);

    const monthIndex = this.displayedColumns.indexOf('Month');
    if (monthIndex > -1) {
      this.displayedColumns.splice(monthIndex, 1);
      this.displayedColumns.unshift('Month');
    }
  }

  initializeChart() {
    const ctx = document.getElementById('myChart') as HTMLCanvasElement;

    if (this.myChart) {
      this.myChart.destroy();
    }

    const filteredYearList = this.monthYearDataForChart.filter(item => item.Month !== 'Annual');
    const labels = filteredYearList.map(item => item.Month);
    const years = Object.keys(filteredYearList[0]).filter(key => key !== 'Month');

    const datasets = this.createDatasets(filteredYearList, years);

    this.myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: datasets
      },
      options: this.getChartOptions()
    });
  }

  createDatasets(filteredYearList, years) {
    const colors = this.getColors();

    return years.map((year, index) => ({
      label: year,
      data: filteredYearList.map(item => item[year]),
      backgroundColor: colors[index % colors.length],
      borderWidth: 1
    }));
  }

  getColors() {
    return [
      '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#E7E9ED', '#76C7C0',
      '#F45B5B', '#1D3557', '#2A9D8F', '#E76F51', '#8E44AD', '#3498DB', '#2ECC71', '#E74C3C',
      '#F1C40F', '#34495E', '#9B59B6', '#27AE60', '#F39C12', '#D35400', '#BDC3C7', '#7F8C8D', '#16A085'
    ];
  }

  getChartOptions() {
    return {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            const datasetLabel = data.datasets[tooltipItem.datasetIndex].label;
            const value = tooltipItem.yLabel;
            return `${datasetLabel}: $${value}`;
          }
        }
      },
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'top',
          color: '#000',
          font: {
            weight: 'bold'
          },
          formatter: function (value) {
            return `$${value}`;
          }
        }
      }
    };
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  onSelectYear($event) {
    this.selectedFromYear = $event.id;
  }

  onDeSelectYear($event) {
    this.selectedFromYear = 0;
  }

  onDeSelectAllYear($event) {
    this.selectedFromYear = 0;
  }

  onSelectToYear($event) {
    this.selectedToYear = $event.id;
  }

  onDeSelectToYear($event) {
    this.selectedToYear = 0;
  }

  onDeSelectAllToYear($event) {
    this.selectedToYear = 0;
  }

  getColorForYear(year: string): string {
    if (this.yearColors[year]) {
      return this.yearColors[year];
    }

    const color = this.getRandomColor();
    this.yearColors[year] = color;
    return color;
  }

  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getPredefinedColors(): string[] {
    return ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF'];
  }

  // ExportBriefingsStatsReport() {
  //   if (this.monthYearData.length > 0) {
  //     let tableData = document.getElementById("ExportTable").innerHTML;

  //     var uri = 'data:application/vnd.ms-excel;base64,'
  //       , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
  //       , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
  //       , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
  //     let html = "<table><tr class='mainhead'> <td colspan='3'>";
  //     html += tableData;
  //     html += "</td></tr></table>";
  //     let name = 'ExportBriefingsStatsReport';
  //     var ctx = { worksheet: name || 'Worksheet', table: html }
  //     FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportBriefingsStatsReport.xls");
  //   }
  //   else {
  //     this.isloading = false;
  //     this.toastrService.error("No record found", "Error");
  //   }
  // }
  

  ExportBriefingsStatsReport() {
  if (this.monthYearData.length > 0) {

    let tableData = document.getElementById("ExportTable").innerHTML;
    let canvas = document.getElementById('myChart') as HTMLCanvasElement;
    let chartImage = canvas.toDataURL('image/png');

    let html = `
      <table border="0">
        <tr>
          <td colspan="3">${tableData}</td>
        </tr>
        <tr>
          <td colspan="3">
            <img src="${chartImage}" />
          </td>
        </tr>
      </table>
    `;

    let uri = 'data:application/vnd.ms-excel;base64,';
    let template = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office"
            xmlns:x="urn:schemas-microsoft-com:office:excel"
            xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <!--[if gte mso 9]>
        <xml>
          <x:ExcelWorkbook>
            <x:ExcelWorksheets>
              <x:ExcelWorksheet>
                <x:Name>ExportBriefingsStatsReport</x:Name>
                <x:WorksheetOptions>
                  <x:DisplayGridlines/>
                </x:WorksheetOptions>
              </x:ExcelWorksheet>
            </x:ExcelWorksheets>
          </x:ExcelWorkbook>
        </xml>
        <![endif]-->
      </head>
      <body>{table}</body>
      </html>
    `;

    let base64 = (s: string) => window.btoa(unescape(encodeURIComponent(s)));
    let format = (s: string, c: any) =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    let ctx = { table: html };

    FileSaver.saveAs(
      uri + base64(format(template, ctx)),
      'ExportBriefingsStatsReport.xls'
    );

  } else {
    this.toastrService.error("No record found", "Error");
  }
}

}
